<template>
  <div :class="classes">
    <span v-if="left != null" class="left-value">{{ left }}</span>
    <div
      v-bind:class="{
        'bx-complementary-bar': !more,
        'bx-complementary-bar-more': more
      }"
    >
      <div class="bx-bar" :style="`width: ${percent}%`"></div>
    </div>
    <span v-if="right != null" class="right-value">{{ right }}</span>
  </div>
</template>

<script>
export default {
  name: "bx-complementary-mini",
  props: {
    percent: {
      type: Number,
      required: true
    },
    left: {
      type: [Number, String]
    },
    right: {
      type: [Number, String]
    },
    more: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes() {
      const classes = ["bx-complementary-mini"];
      return classes;
    }
  }
};
</script>
